import { Html5Qrcode } from 'html5-qrcode';
import { Html5QrcodeScanType, QrcodeSuccessCallback } from 'html5-qrcode/esm/core';
import { useEffect } from 'react';

const barcodeRegionId = 'teceo-html5-barcode';

const cameraConfig = {
  fps: 10,
  supportedScanTypes: [Html5QrcodeScanType.SCAN_TYPE_CAMERA],
};

type Html5QrcodePluginProps = {
  onSuccess: QrcodeSuccessCallback;
  width: number;
  height: number;
  cameraId: string;
};

const Html5QrcodePlugin = ({ onSuccess, width, height, cameraId }: Html5QrcodePluginProps) => {
  useEffect(() => {
    if (!cameraId) {
      return;
    }

    const scanner = new Html5Qrcode(barcodeRegionId);

    scanner.start(
      cameraId,
      {
        ...cameraConfig,
        qrbox: {
          width,
          height,
        },
      },
      (text, result) => {
        onSuccess(text, result);
        scanner.stop().then(() => {
          scanner.clear();
        });
      },
      (err) => {
        if (!err.includes('No MultiFormat Readers were able to detect the code')) {
          console.error(err);
        }
      },
    );

    return () => {
      if (scanner.isScanning) {
        scanner.stop().then(() => {
          scanner.clear();
        });
      }
    };
  }, [cameraId]);
  return <div id={barcodeRegionId} />;
};

export default Html5QrcodePlugin;
